export default __webpack_public_path__ + "static/media/Path671@2x.6ebb9c92.png";